import React from 'react'

const ContactUs = () => {
  return (
    <div className="pt-6">
        <h1 className="font-Bree text-white text-5xl ">Contact Us</h1>
        <h2 className="font-Bree text-white text-3xl mt-4">VIKASPURI</h2>
        <h2 className="font-Bree text-white text-2xl py-2">FG-1 20A , Vikas Puri ,New Delhi</h2>
        <h2 className="font-Bree text-white text-2xl">+91-7827277757</h2>

        <h2 className="font-Bree text-white text-3xl mt-4">ROHINI</h2>
        <h2 className="font-Bree text-white text-2xl py-2">Shop No. 196 , G.F Pkt-3, Sec-24 ,Rohini , Delhi</h2>
        <h2 className="font-Bree text-white text-2xl">+91-7068686827 , +91-9506120058</h2>
    </div>
  )
}

export default ContactUs